import ProgramRegistrationPopup from './ProgramRegistrationPopup';

export default {
    ProgramRegistrationPopup,
};

export {
    ProgramRegistrationPopup,
};